import { render, staticRenderFns } from "./OrgUsersList.vue?vue&type=template&id=89ba94ea&scoped=true&"
import script from "./OrgUsersList.vue?vue&type=script&lang=js&"
export * from "./OrgUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ba94ea",
  null
  
)

export default component.exports